import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/banks/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}banks/delete`,
        endpoint: config.endpoints.backend + 'banks/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall'
    }

    let list = {
        labelTitle: 'Lista de Bancos',
        labelTitleButtonAdd: 'Incluir novo banco',
        fieldsShowOnDelete: ['accountid'],
        showPrintButtons: true,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'code',
                label: 'Código do Banco'
            },
            {
                name: 'name',
                label: 'Banco'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
